module.exports = __webpack_public_path__ + "img/partners_2.3f81db3d.png";